import moment from 'moment'
import { getI18n } from '../../plugins/i18n'
import { isEmpty, isEmptyArray, isNullOrUndefined } from './helpers'

const t = (key, params) => getI18n().global.t(key, params)

// 👉 Required Validator
export const requiredValidator = value => {
  if (isNullOrUndefined(value) || isEmptyArray(value) || value === false)
    return t('Validation.required')
  
  return !!String(value).trim().length || t('Validation.required')
}

// 👉 Email Validator
export const emailValidator = value => {
  if (isEmpty(value))
    return true
  const re = /^(?:[^<>()[\]\\.,;:\s@"]+(?:\.[^<>()[\]\\.,;:\s@"]+)*|".+")@(?:\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\]|(?:[a-z\-\d]+\.)+[a-z]{2,})$/i
  if (Array.isArray(value))
    return value.every(val => re.test(String(val))) || t('Validation.email')
  
  return re.test(String(value)) || t('Validation.email')
}

// 👉 Password Validator
export const passwordValidator = password => {
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/
  const validPassword = regExp.test(password)
  
  return validPassword || t('Validation.password')
}

// 👉 Confirm Password Validator
export const confirmedValidator = (value, target) => value === target || t('Validation.confirmed')

// 👉 Phone Validator
export const phoneValidator = value => {
  if (isEmpty(value))
    return true
  
  return /^0\(\d{3}\) \d{3} \d{2} \d{2}$/.test(String(value)) || t('Validation.phone')
}

// 👉 Regex Validator
export const regexValidator = (value, regex) => {
  if (isEmpty(value))
    return true
  let regeX = regex
  if (typeof regeX === 'string')
    regeX = new RegExp(regeX)
  if (Array.isArray(value))
    return value.every(val => regexValidator(val, regeX))
  
  return regeX.test(String(value)) || t('Validation.regex')
}

// 👉 Alpha Validator
export const alphaValidator = value => {
  if (isEmpty(value))
    return true
  
  return /^[A-Z]*$/i.test(String(value)) || t('Validation.alpha')
}

// 👉 URL Validator
export const urlValidator = value => {
  if (isEmpty(value))
    return true
  const re = /^https?:\/\/[^\s$.?#].\S*$/
  
  return re.test(String(value)) || t('Validation.url')
}

// 👉 Length Validator
export const lengthValidator = (value, length) => {
  if (isEmpty(value))
    return true
  
  return String(value).length === length || t('Validation.length', { length })
}

// 👉 Alpha-dash Validator
export const alphaDashValidator = value => {
  if (isEmpty(value))
    return true
  const valueAsString = String(value)
  
  return /^[\w-]*$/.test(valueAsString) || t('Validation.alphaDash')
}

// 👉 Time Validator
export const timeValidator = value => {
  if (isEmpty(value))
    return true
  
  return /^([01]\d|2[0-3]):?([0-5]\d)$/.test(String(value)) || t('Validation.time')
}

// 👉 Length Max Validator
export const lengthMaxValidator = (value, length) => {
  if (isEmpty(value))
    return true
  
  return String(value).length <= length || t('Validation.lengthMax', { length })
}

// 👉 Length Between Validator
export const lengthBetweenValidator = (value, min, max) => {
  if (isEmpty(value))
    return true
  const length = String(value).length
  
  return (length >= min && length <= max) || t('Validation.lengthBetween', { min, max })
}



// sayi validator


// 👉 Tam Sayı Doğrulayıcı
export const integerValidator = value => {
  if (isEmpty(value)) return true
  if (Array.isArray(value))
    return (
      value.every(val => /^-?\d+$/.test(String(val))) ||
      t('Validation.integer')
    )

  return /^-?\d+$/.test(String(value)) || t('Validation.integer')
}

// Min Sayı Doğrulayıcı
export const minValidator = (value, min) => {
  const valueAsNumber = Number(value)

  // Eğer sayı değilse hata mesajı döndür
  if (isNaN(valueAsNumber)) {
    return t('Validation.validNumber')
  }

  // Minimum ve maksimum değerleri kontrol et
  if (valueAsNumber < min) {
    return t('Validation.min', { min })
  }
  
  return true // Eğer her şey doğruysa true döner
}

// Min ve Max Sayı Doğrulayıcı
export const minMaxValidator = (value, min, max) => {
  // Değer boşsa geçerli kabul et
  if (!value || value.trim() === "") {
    return true // Boşsa geçerli
  }

  const valueAsNumber = Number(value) // Değeri sayıya çevir

  // Eğer sayı değilse hata mesajı döndür
  if (isNaN(valueAsNumber)) {
    return t('Validation.validNumber')
  }

  // Minimum ve maksimum değerleri kontrol et
  if (valueAsNumber < min) {
    return t('Validation.min', { min })
  } else if (valueAsNumber > max) {
    return t('Validation.max', { max })
  }

  return true // Eğer her şey doğruysa true döner
}

// 👉 Length Min Validator
export const lengthMinValidator = (value, length) => {
  if (isEmpty(value))
    return true
  
  return String(value).length >= length || t('Validation.lengthMin', { length })
}


// 👉 Aralık Doğrulayıcı
export const betweenValidator = (value, min, max) => {
  const valueAsNumber = Number(value)

  return (
    (Number(min) <= valueAsNumber && Number(max) >= valueAsNumber) ||
    t('Validation.between', { min, max })
  )
}

// Min ve iki alan min kadar olmalı
export const minIkiAlanValidator = (value1, value2, min) => {
  const valueAsNumber1 = Number(value1)
  const valueAsNumber2 = Number(value2)

  if (isNaN(valueAsNumber1) || isNaN(valueAsNumber2)) {
    return t('Validation.validNumber')
  }

  // Eğer her iki değer de min'den küçükse hata döndür
  if (valueAsNumber1 < min && valueAsNumber2 < min) {
    return t('Validation.minTwoFields', { min })
  }
  
  return true // Eğer her şey doğruysa true döner
}

export const decimalMinValidator = (value, min) => {
  const valueAsNumber = parseFloat(value) // Girdiyi ondalık sayıya çevir
  const minAsNumber = parseFloat(min)

  // Geçerli bir sayı mı kontrol et
  if (isNaN(valueAsNumber)) {
    return t('Validation.validNumber')
  }

  // Aralıkta mı kontrol et
  if (valueAsNumber < minAsNumber) {
    return t('Validation.min', { min })
  }

  // Geçerli ise true döndür
  return true
}
export const decimalBetweenValidator = (value, min, max) => {
  const valueAsNumber = parseFloat(value) // Girdiyi ondalık sayıya çevir
  const minAsNumber = parseFloat(min)
  const maxAsNumber = parseFloat(max)

  // Geçerli bir sayı mı kontrol et
  if (isNaN(valueAsNumber)) {
    return t('Validation.validNumber')
  }

  // Aralıkta mı kontrol et
  if (valueAsNumber < minAsNumber || valueAsNumber > maxAsNumber) {
    return t('Validation.between', { min, max })
  }

  // Geçerli ise true döndür
  return true
}


// 👉 Arac ile ilgili validatorlar

// 👉 Sase Doğrulayıcı
// Şase Numarası Formatı
// Şase numarası, ISO 3779:2009 standardına uygun olarak yapılandırılır ve 3 ana bölüme ayrılır:
//     WMI (World Manufacturer Identifier - Üretici Kodu):
//         İlk 3 karakter.
//         Üretici ve üretim yerini tanımlar.

//     VDS (Vehicle Descriptor Section - Araç Tanım Kısmı):
//         4-9. karakterler.
//         Araç modeli, gövde tipi, motor tipi gibi bilgileri içerir.

//     VIS (Vehicle Identifier Section - Araç Kimlik Kısmı):
//         Son 8 karakter.
//         Üretim yılı, üretim yeri ve üretim sırasını belirler.
export const saseValidator = value => {
  if (!validateVin(value)) {
    return t('Validation.sase')
  } else return true
}

const vinWeights = [8, 7, 6, 5, 4, 3, 2, 10, 0, 9, 8, 7, 6, 5, 4, 3, 2]

const vinValues = {  A: 1,  B: 2,  C: 3,  D: 4,  E: 5,  F: 6,  G: 7,  H: 8,  J: 1,  K: 2,  L: 3,  M: 4,  N: 5,  P: 7,  R: 9,  S: 2,  T: 3,  U: 4,  V: 5,  W: 6,  X: 7,  Y: 8,  Z: 9,  0: 0,  1: 1,  2: 2,  3: 3,  4: 4,  5: 5,  6: 6,  7: 7,  8: 8,  9: 9 }

/**
 * Validate a VIN (Vehicle Identification Number).
 * @param {string} vin - The VIN to validate.
 * @returns {boolean} True if the VIN is valid, false otherwise.
 */
function validateVin(vin) {
  if (vin.length !== 17) {
    return false // VIN must be exactly 17 characters long.
  }

  let total = 0
  for (let i = 0; i < vin.length; i++) {
    const char = vin[i]
    const value = vinValues[char]
    if (value === undefined) {
      return false // Invalid character in VIN.
    }
    total += value * vinWeights[i]
  }

  const remainder = total % 11
  const checkDigit = remainder === 10 ? "X" : String(remainder)

  // console.log(vin[8]);
  // console.log(checkDigit);
  // Validate the 9th character (check digit).
  return vin[8] === checkDigit
}

// 👉 Start Date Validator
export const startDateValidator = (value, target) => {
  if (isEmpty(value)) return true
  if (isEmpty(target)) return true

  const start = new Date(value)
  const end = new Date(target)

  return start <= end || t("Başlangıç Tarihi Bitiş Tarihinden sonra olamaz")
}

// 👉 End Date Validator
export const endDateValidator = (value, target) => {
  if (isEmpty(value)) return true
  if (isEmpty(target)) return true

  const start = new Date(target)
  const end = new Date(value)

  return end >= start || t("Bitiş Tarihi Başlangıç Tarihinden önce olamaz")
}

// 👉 Fatura AI Date Validator
export const faturaAIDateValidator = (value, target) => {
  if (isEmpty(value) || isEmpty(target)) return true

  const date = moment(value)
  const targetDate = moment(target)

  if (date.isSameOrBefore(targetDate, 'day')) {
    return t('Bu tarihe mesai girilemez.')
  }

  return true
}
